import React from 'react';
import { graphql } from 'gatsby';
import { gql, useQuery } from '@apollo/client';

import Layout from '../../components/Layout';
import { Promises } from '../../components/Sections/Promises';
import { Testimonials } from '../../components/Sections/Testimonials';
import { SleepDeprivation } from '../../components/Sections/SleepDeprivation';
import { Doctors } from '../../components/Sections/Doctors';
import SEO from '../../components/seo';

import { ProductDetails } from './ProductDetails';

const GET_PRODUCT = gql`
  query PRODUCT($handle: String!) {
    productByHandle(handle: $handle) {
      id
      title
      handle
      productType
      variants(first: 100) {
        edges {
          node {
            id
            price
            compareAtPrice
            availableForSale
            title
          }
        }
      }
    }
  }
`;

const ProductPage = ({ data }) => {
  const { title, productType, handle } = data.shopifyProduct;
  const { data: liveProductData, error } = useQuery(GET_PRODUCT, {
    variables: {
      handle,
    },
  });

  return (
    <Layout>
      <SEO keywords={[`bluli`, `blue-light`, `screen-protectors`, productType, `e-commerce`]} title={title} />
      <ProductDetails
        product={data.shopifyProduct}
        liveProduct={liveProductData ? liveProductData.productByHandle : null}
      />
      <SleepDeprivation />
      <Doctors />
      <Promises />
      <Testimonials />
    </Layout>
  );
};

export const query = graphql`
  query($handle: String!) {
    shopifyProduct(handle: { eq: $handle }) {
      id
      title
      handle
      productType
      description
      descriptionHtml
      shopifyId
      options {
        id
        name
        values
      }
      variants {
        id
        shopifyId
        price
        priceV2 {
          amount
          currencyCode
        }
        compareAtPrice
        compareAtPriceV2 {
          amount
          currencyCode
        }
        title
        availableForSale
        selectedOptions {
          name
          value
        }
      }
      images {
        originalSrc
        id
        localFile {
          childImageSharp {
            fluid(maxWidth: 910) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    }
  }
`;

export default ProductPage;
